import { api } from '../core';
import { BUNDLE_CATEGORY_LIST_TAG } from '../constants';
import { type BundleTypeKeys, RootState, setBundleCategoriesList } from '@/store';

export interface BundleCategoryItem {
  categoryId: string;
  categoryName: string;
  inBundles: boolean;
}

type BundleCategoryListResponse = BundleCategoryItem[];

type GetBundleCategoryListProps = {
  bundleId: string;
  bundleKey?: BundleTypeKeys;
};

export const getBundleCategoryListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundleCategoryList: builder.query<BundleCategoryListResponse, GetBundleCategoryListProps>({
      query: ({ bundleId }: GetBundleCategoryListProps) => ({
        url: `bundle/category/list?bundle_id=${bundleId}`,
        method: 'GET'
      }),
      providesTags: (_result, _err, { bundleId }) => [{ type: BUNDLE_CATEGORY_LIST_TAG, id: bundleId }],
      async onQueryStarted({ bundleKey }, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          const state = getState() as RootState;
          const resolvedBundleKey = bundleKey ?? state.sharedData.activeBundleType;

          if (data && resolvedBundleKey) {
            dispatch(
              setBundleCategoriesList({
                key: resolvedBundleKey,
                data: data
              })
            );
          }
        } catch (error) {
          console.error('Error in getBundleCategoryList in onQueryStarted:', error);
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundleCategoryListQuery } = getBundleCategoryListApi;
